// config
export const RECEIVE_CONFIG_SITE = 'RECEIVE_CONFIG_SITE';
export const RECEIVE_TEMPLATE = 'RECEIVE_TEMPLATE';

// content
export const RECEIVE_TEXT_CONTENT = 'RECEIVE_TEXT_CONTENT';

// destination
export const SET_DESTINATION_URGENCY_MEASUREMENTS = 'SET_DESTINATION_URGENCY_MEASUREMENTS';
export const SET_DESTINATION_INFOGRAPHIC = 'SET_DESTINATION_INFOGRAPHIC';
export const SET_UNIT_REVIEWS = 'SET_UNIT_REVIEWS';
export const SET_QUICK_SERP_FILTERS = 'SET_QUICK_SERP_FILTERS';

// listings
export const LOADING_LISTINGS = 'LOADING_LISTINGS';
export const FAILED_LISTINGS = 'FAILED_LISTINGS';
export const SET_LISTINGS = 'SET_LISTINGS';

// i18n
export const RECEIVE_LOCALE = 'RECEIVE_LOCALE';

// mvt
export const EXPOSE_TEST = 'EXPOSE_TEST';

// search
export const RECEIVE_SERP_URL_DOMAIN = 'RECEIVE_SERP_URL_DOMAIN';
export const RECEIVE_REFINEMENTS = 'RECEIVE_REFINEMENTS';
export const RECEIVE_KEYWORDS = 'RECEIVE_KEYWORDS';
export const RECEIVE_ARRIVAL_DATE = 'RECEIVE_ARRIVAL_DATE';
export const RECEIVE_DEPARTURE_DATE = 'RECEIVE_DEPARTURE_DATE';
export const REDIRECT = 'REDIRECT';
export const HIDE_DATES_POPUP = 'HIDE_DATES_POPUP';
export const SHOW_DATES_POPUP = 'SHOW_DATES_POPUP';
export const UPDATE_SEARCH = 'UPDATE_SEARCH';

// great places
export const HIGHLIGHT_IN_MAP = 'HIGHLIGHT_IN_MAP';
export const CLEAR_MAP_HIGHLIGHT = 'CLEAR_MAP_HIGHLIGHT';
export const NAVIGATE_CAROUSEL = 'NAVIGATE_CAROUSEL';
export const CLEAR_CAROUSEL_FOCUS = 'CLEAR_CAROUSEL_FOCUS';
export const HIDE_GOOGLE_MAP = 'HIDE_MAP';

// property types
export const SET_PROPERTY_TYPE_IMAGE_URL = 'SET_PROPERTY_TYPE_IMAGE_URL';
export const SET_PROPERTY_TYPES_PRICE = 'SET_PROPERTY_TYPES_PRICE';
